import CodeCell from './CodeCell';

export default CodeCell;